import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import PortfolioLayout from "../layouts/PortfolioLayout";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import usePageMeta from "../Helpers/usePageMeta";

const Portfolio = () => {
  usePageMeta({
    title: "Portfolio | TZ Creation",
    description:
      "Browse TZ Creation's portfolio -- web design, UI/UX, branding, logo and social media projects, all in one place.",
    path: "/portfolio",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Portfolio" />
      <PortfolioLayout />
      <TestimonialSlider />
      <Footer />
    </>
  );
};

export default Portfolio;
